import { lazy, memo, useCallback, useContext, useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { useMediaQuery } from "../../../core/hooks/useMediaQuery";
//import ApiAuth from "../../../core/api/api.auth";


const MobileFooter = lazy(() => import(/* webpackChunkName: "MobileFooter" */ "./MobileFooter"));
const DesktopFooter = lazy(() => import(/* webpackChunkName: "DesktopFooter" */ "./DesktopFooter"));

function FooterNav() {
  const isMobile = useMediaQuery('(max-width: 991px)');

  return (
    <footer>
      {/* ***** mobile ******************************************* */}
      {isMobile ? (
        <MobileFooter />
      ) : (
        // ***** desktop *******************************************
        <DesktopFooter />
      )}
    </footer>
  );
}
export default memo(FooterNav);

